exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host /deep/ .centers {\n  margin: 14px 0; }\n\n:host /deep/ .centers__head-left, :host /deep/ .centers__row-left {\n  float: left;\n  width: 34%;\n  margin: 0;\n  padding-right: 6px; }\n\n:host /deep/ .centers__head-right, :host /deep/ .centers__row-right {\n  float: right;\n  width: 66%;\n  margin: 0;\n  padding-left: 6px; }\n\n:host /deep/ .centers__list {\n  margin-top: 4px; }\n\n:host /deep/ .centers__row + .centers__row {\n  margin-top: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?{"includePaths":["/root/src/ui","/root/src/ui/node_modules"]}!./~/import-glob-loader!./app/common/forms/centers-select.component.sass
// module id = 1093
// module chunks = 4